/* eslint-disable no-console */
import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const refrigerantUsed = async (): Promise<any> => {
  const refridgentUsed = useJSONStore.getState().refridgentUsed;
  const token = useUserStore.getState().userToken;
  const setRefridgentUsed = useJSONStore.getState().setRefridgentUsed;

  if (refridgentUsed.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.fugitiveType}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setRefridgentUsed(res.data.data);
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default refrigerantUsed;
